import { IonCol } from '@ionic/react';
import React, { useEffect } from 'react';
import PostCard from './PostCard';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getPosts } from '../../actions/post';

const PostList = ({ getPosts, stat, post: { posts }, filter = '' }) => {
  useEffect(() => {
    getPosts();
    // eslint-disable-next-line
  }, []);

  const l = [...posts].sort((a, b) => a['postedWhen'] - b['postedWhen']);
  let t = [...posts].sort((a, b) => b['noOflikes'] - a['noOflikes']);

  const query = filter.toLowerCase();
  t = t.filter((post) => {
    return (
      post.title.toLowerCase().includes(query) ||
      post.desc.toLowerCase().includes(query) ||
      post.topic.toLowerCase().includes(query) ||
      post.content.toLowerCase().includes(query) ||
      post.authorName.toLowerCase().includes(query)
    );
  });

  return (
    <IonCol sizeLg='8' sizeMd='auto'>
      {stat === 'latest' ? l.map((post) => <PostCard post={post} />) : t.map((post) => <PostCard post={post} />)}
    </IonCol>
  );
};

PostList.propTypes = {
  getPosts: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  stat: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
  auth: state.register,
  post: state.post,
  stat: props.stat,
});

export default connect(mapStateToProps, { getPosts })(PostList);
